var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99926 12.5002L2.99926 12.5L13 3.50082L22.9993 12.5016L19.9993 12.5014L19.9986 20.5014L13.9986 20.5009L13.9991 14.5009L11.9991 14.5007L11.9986 20.5007L5.99861 20.5002L5.99926 12.5002ZM17.9994 10.6912L12.9998 6.19082L7.99941 10.6904L7.99877 18.5004L9.99877 18.5006L9.99926 12.5006L15.9993 12.5011L15.9988 18.5011L17.9988 18.5012L17.9994 10.6912Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome24Px);
export default __webpack_public_path__ + "static/media/home_24px.5eb739001b465af83e7751ac684b04da.svg";
export { ForwardRef as ReactComponent };